import React from "react";

const LogoutRedIcon = ({width=15,height=15}) => {
  return (
    <svg width={width} height={height} cursor="pointer"  viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.69667 4.69667C3.64779 5.74556 2.93349 7.08194 2.64411 8.53679C2.35473 9.99165 2.50326 11.4996 3.07092 12.8701C3.63858 14.2405 4.59987 15.4119 5.83324 16.236C7.0666 17.0601 8.51665 17.4999 10 17.4999C11.4834 17.4999 12.9334 17.0601 14.1668 16.236C15.4001 15.4119 16.3614 14.2405 16.9291 12.8701C17.4968 11.4996 17.6453 9.99165 17.3559 8.53679C17.0665 7.08194 16.3522 5.74556 15.3033 4.69667M10 2.5V10" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    
  );
};

export default LogoutRedIcon;
